export default __webpack_public_path__ + "static/media/c3.689f2e54.png";